import { API_PREFIX, API_VERSION } from "@/model/communication/Command";

export enum UserLongTaskStatus {
    running,
    completed,
}

export enum UserLongTaskType {
    cashReport,
}

export class UserLongTask {
    id: string;
    clientUserName: string;
    status: UserLongTaskStatus;
    type: UserLongTaskType;
    inputData: string;
    createdAt: Date;
    completedAt: Date | undefined;
    executorServerName: string;

    parse(data: any) {
        this.id = data.ID;
        this.clientUserName = data.ClientUserName;
        this.status = data.Status;
        this.type = data.Type;
        this.inputData = data.InputData;
        this.createdAt = data.CreatedAt;
        this.completedAt = data.CompletedAt;
        this.executorServerName = data.ExecutorServerName;
    }

    getDownloadPath() {
        return API_PREFIX + API_VERSION + "/user_long_task/" + this.id;
    }
}
